module.exports = __webpack_public_path__ + "static/media/bingo-safari.e6f8d42e.png";